import { IAppState } from '@myStore/app.state';
import { IEventsChangesState } from '@myStore/events-changes/events-changes.state';
import { createSelector } from '@ngrx/store';

const eventsChangesSelector = (state: IAppState) => state.eventsChanges;

export const selectChangesEventLoading = createSelector(
  eventsChangesSelector,
  (state: IEventsChangesState) => state?.isLoading
);

export const selectChangesEventFileLoading = createSelector(
  eventsChangesSelector,
  (state: IEventsChangesState) => state?.fileLoading
);

export const selectEventMaterialsLoading = createSelector(
  eventsChangesSelector,
  (state: IEventsChangesState) => state?.materialLoading
);

export const selectEventLinkLoading = createSelector(
  eventsChangesSelector,
  (state: IEventsChangesState) => state?.linkLoading
);

export const selectChangesEventSuccess = createSelector(
  eventsChangesSelector,
  (state: IEventsChangesState) => state?.success
);

export const selectChangesEventFailure = createSelector(
  eventsChangesSelector,
  (state: IEventsChangesState) => state?.errors
);
